import { lazy } from "react";

export const Announcement = lazy(() => import("components/alerts/InfoBar/Announcement"));
